import { Flex, isNullish } from "@theorgchartdev/storybook";
import { GetDoc } from "@/Utils/StateLib";
import { SavedFilterHighlightList } from "../HighlightsPanel/SavedFilterHighlightList";

export const SavedFilters = () => {
  const ApplySavedContent =
    ({ ToggleSavedContent, ApplyChartFilters }) =>
    event => {
      ToggleSavedContent(event.target.id);
      ApplyChartFilters();
    };

  const GetSavedContent = () => {
    const filterMgr = GetDoc()?.GetFilterMgr();
    if (isNullish(filterMgr)) {
      return [];
    }

    return filterMgr.GetAllowedFilterList();
  };

  const GetNormalizedSavedList = () => {
    const filterMgr = GetDoc()?.GetFilterMgr();
    if (isNullish(filterMgr)) {
      return [];
    }

    const savedData = filterMgr.GetAllowedFilterList();
    let savedList = savedData.map((item, index) => ({
      name: item.GetFilterName(),
      id: index,
      enabled: item.GetFilterApplied(),
      hidden: item.fHidden
    }));

    return savedList.filter(item => !item.hidden);
  };

  return (
    <Flex
      padding={"4px 0 0 0"}
      height={"100%"}
      className={"ocn-list-scrollbar"}
      flex={"1"}
      direction={"column"}
      gap={"18px"}
      overflow={"auto"}
    >
      <SavedFilterHighlightList
        type={"filters"}
        GetSavedContent={GetSavedContent}
        ApplySavedContent={ApplySavedContent}
        GetNormalizedSavedList={GetNormalizedSavedList}
        showHeader={false}
      />
    </Flex>
  );
};
